import { render, staticRenderFns } from "./ColumnGroup.vue?vue&type=template&id=be70f096&scoped=true&"
import script from "./ColumnGroup.vue?vue&type=script&lang=ts&"
export * from "./ColumnGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnGroup.vue?vue&type=style&index=0&id=be70f096&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be70f096",
  null
  
)

export default component.exports